

<template>
    <HeaderContent title="Maintenance"/>
    <ActionContent :cta="false" ctaText="Room Maintenance" @action="modal = !modal" :filterDate="false" @showFilter="modalFilter = !modalFilter"/>
    <MaintenanceStatistics title="Maintenance Statistics" :data="statistics" />
    <MaintenanceForm :modal="modal" @update:modal="modal = $event"/>
    <MaintenanceDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
  </template>
  <script>
  
  import { ref } from 'vue';
  import HeaderContent from '@/components/HeaderContent.vue';
  import ActionContent from '@/components/ActionContent.vue';
  import MaintenanceForm from "./MaintenanceForm.vue";
  import MaintenanceStatistics from "@/components/StatisticData.vue";
  import MaintenanceDataTable from "@/components/DataTable.vue";
  import iconToday from '../../../public/icons/sun.svg';
  import iconWeek from '../../../public/icons/week.svg';

  export default {
    components: {
      HeaderContent,
      ActionContent,
      MaintenanceForm,
      MaintenanceStatistics,
      MaintenanceDataTable,
    },
    setup(){
      const modal = ref(false)

      const showModal = () => {
        modal.value = true
      }
      const data = ref([
        { 
          no: 1, 
          type_room: 'Deluxe', 
          no_room: 'A3', 
          status_maintenance: 'Under Maintenance',
          start_maintenance: '14/02/2025', 
          end_maintenance: '15/02/2025 15:00', 
          remark: 'Ac Rusak',
          technician_name: 'Zul', 
          
        },
        { 
          no: 1, 
          type_room: 'Super Deluxe', 
          no_room: 'A2', 
          status_maintenance: 'Under Maintenance',
          start_maintenance: '14/02/2025', 
          end_maintenance: '15/02/2025 15:00', 
          remark: 'Ac Rusak', 
          technician_name: 'Ridho',
          
        },
        { 
          no: 1, 
          type_room: 'Honeymoon', 
          no_room: 'A1', 
          status_maintenance: 'Under Maintenance',
          start_maintenance: '14/02/2025', 
          end_maintenance: '15/02/2025 15:00', 
          remark: 'Pengecatan', 
          technician_name: 'Reza',
          
        },
        { 
          no: 1, 
          type_room: 'Family', 
          no_room: 'A5', 
          status_maintenance: 'Maintenance Completed',
          start_maintenance: '14/02/2025', 
          end_maintenance: '15/02/2025 15:00', 
          remark: 'Ac Rusak', 
          technician_name: 'Raja',
          
        },
        { 
          no: 1, 
          type_room: 'Studio', 
          no_room: 'A4', 
          status_maintenance: 'Maintenance Completed',
          start_maintenance: '14/02/2025', 
          end_maintenance: '15/02/2025 15:00', 
          remark: 'Pengecatan', 
          technician_name: 'Madan',
          
        },
      ]);
      const headers = ref([
        {
          key: 'type_room',
          label: 'Room Type',
          sortable: true,
        },
        {
          key: 'no_room',
          label: 'Room Number',
          sortable: true,
        },
        {
          key: 'status_maintenance',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'start_maintenance',
          label: 'Start Maintenance',
          sortable: true,
        },
        {
          key: 'end_maintenance',
          label: 'End Maintenance',
          sortable: true,
        },
        {
          key: 'remark',
          label: 'Remark',
          sortable: true,
        },
        {
          key: 'technician_name',
          label: 'Technician',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
        }
      ])
      const customActions = ref([
        {
            label: 'Update',
            variant: 'success',
            icon: 'fas fa-check-circle',
            action: (item) => {
              modal.value = true
            console.log('Update action clicked for:', item);
            // Implement your Update logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
        
      ]);
      const statistics = ref([
        {
          label: 'Total',
          key: 'Today',
          value: 3,
          color: 'primary',
          icon: iconToday,
        },
        {
          label: 'Total',
          key: 'Week',
          value: 8,
          color: 'primary',
          icon: iconWeek,
        },
      ])

      return{
        showModal,
        data,
        headers,
        modal,
        customActions,
        statistics,
      }
    }
  
  
  }
  </script>
  
  
  <style>
  
  </style>